export default __webpack_public_path__ + "static/media/singpass-wave.8896aa2a.svg";